import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import logoWhite from '../../images/whiteLogo.png';
import uberLogo from '../../images/uberLogo.png';
import moment from 'moment';
import appleIcon from '../../images/applestore.svg';
import googleIcon from '../../images/googleplay.svg';
import './NYCFooter.css';

const TorontoFooter = () => {
  const isMobile = window.innerWidth < 768;

  return (
    <footer className="fp-auto-height nyc_footer">
      <div className="nyc_footer__container container">
        <div className="nyc_footer__content">
          <div className="nyc_footer__logo">
            <img
              src={logoWhite}
              alt=""
              className="nyc_footer__logo--autzu"
            />
            <p>
              {' '}
              Earn on ridesharing platforms with no upfront costs, no car
              ownership hassle.{' '}
            </p>
            <h4> <b> Notice: Limited Vehicle Availability, May 2025 </b> </h4>
            <p> <span style={{fontWeight:"400"}}>We’re currently making updates to improve our services. During this transition, vehicle availability may be limited, and response times may be delayed.</span> </p>
            <p> <span style={{fontWeight:"400"}}>Drivers are still welcome to sign up and will be notified once more cars are available. For assistance, please email <a href='mailto:customerservice@autzu.com'>customerservice@autzu.com</a> </span> </p>
          </div>
          <div className="nyc_footer__column">

            <h5>Drive</h5>
            <Link to="/tor/ev">Autzu EV</Link>

            <h5>City</h5>
            <Link to="/tor">Toronto</Link>
            <Link to="/sf">San Francisco</Link>
            <Link to="/la">Los Angeles</Link>
            <Link to="/nyc">New York City</Link>
            <Link to="/ott">Ottawa</Link>
          </div>
          <div className="nyc_footer__column">
            <h5>Other</h5>
            <Link to="/tor/aboutus">About us</Link>
            <Link to="/tor/faq">FAQ</Link>
            <Link to="/tor/contact">Contact</Link>
            <Link to="/tor/careers">Careers</Link>
            {/* <Link to="/investors">Investors</Link> */}
            {/* <Link to="/newsroom">Newsroom</Link> */}
            <Link to="/tor/blogs">Blogs</Link>
          </div>
          <div
            className="nyc_footer__column"
            style={{ marginBottom: '32px' }}>
            <h5>Get the App</h5>
            <a
              href="https://apps.apple.com/ca/app/autzu/id1486349150?mt=8"
              className="apple-store-link"
              target="_blank"
              style={{ marginBottom: isMobile ? '8px' : 0 }}>
              <img src={appleIcon} />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.autzu.autzuAndroid&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              className="play-store-link"
              target="_blank">
              <img alt="Get it on Google Play" src={googleIcon} />
            </a>
          </div>
        </div>
      </div>
      <div className="nyc_footer__copyright--container">
        <div className="container nyc_footer__copyright">
          <p className="nyc_footer__copyright--copy">
            &copy; {moment(Date.now()).format('YYYY')} Autzu Inc. All
            rights reserved
          </p>
          <Link to="/tor/terms" className="nyc_footer__copyright--legal">
            Legal
          </Link>
          <Link
            to="/tor/privacy"
            className="nyc_footer__copyright--privacy">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default TorontoFooter;



// WEBPACK FOOTER //
// ./src/components/Layout/TorontoFooter.js